'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _nitroIcon = require('../nitro-icon');

var _nitroIcon2 = _interopRequireDefault(_nitroIcon);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NitroTabs = function NitroTabs(props) {
  var action = props.action,
      active = props.active,
      inactiveVariant = props.inactiveVariant,
      center = props.center,
      data = props.data,
      divider = props.divider,
      large = props.large,
      underline = props.underline,
      variant = props.variant;


  var tabs = data && data.map(function (tab, index) {
    var isTabActive = tab.key === active;

    var handleClick = function handleClick() {
      if (action) action(tab);
    };

    var Tab = _styles.DefaultTab;

    if (divider) {
      Tab = _styles.DividerTab;
    }

    if (underline) {
      Tab = _styles.UnderlineTab;
    }

    var tabVariant = isTabActive ? variant : inactiveVariant;

    var icon = tab.icon && _react2.default.createElement(_nitroIcon2.default, {
      name: tab.icon,
      size: 14,
      right: 8,
      variant: tabVariant
    });

    return _react2.default.createElement(
      Tab,
      {
        active: isTabActive,
        center: center,
        className: 'tab',
        key: tab.key || index,
        large: large,
        onClick: handleClick,
        underline: underline,
        variant: tabVariant
      },
      icon,
      _react2.default.createElement(
        'span',
        null,
        tab.label
      ),
      tab.content
    );
  });

  return _react2.default.createElement(
    _styles.Tabs,
    props,
    tabs
  );
};

NitroTabs.propTypes = {
  data: _propTypes2.default.array.isRequired,
  action: _propTypes2.default.func,
  active: _propTypes2.default.string,
  inactiveVariant: _propTypes2.default.string,
  variant: _propTypes2.default.string,
  divider: _propTypes2.default.bool,
  underline: _propTypes2.default.bool,
  large: _propTypes2.default.bool,
  center: _propTypes2.default.bool,
  stretchHorizontal: _propTypes2.default.bool,
  lineHeight: _propTypes2.default.number,
  className: _propTypes2.default.string
};

NitroTabs.defaultProps = {
  inactiveVariant: 'base3',
  lineHeight: 30,
  variant: 'secondary'
};

exports.default = NitroTabs;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-tabs/NitroTabs.js
// module id = 3040
// module chunks = 4